import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import AdminEmptyState from "@/share/components/admin/AdminEmptyState.vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'EmptyState',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AdminEmptyState, {
    title: "No se encontraron modelos de vehículo",
    description: "Intenta ajustar los filtros o crear un nuevo modelo."
  }))
}
}

})